import React from 'react';

import {useInstanceDetailPage} from '../../../../api/hooks/useInstanceDetail.hook';
import {ButtonVariantsEnum} from '../../../../utils/_enums/button-variants.enum';
import {TypographyVariantsEnum} from '../../../../utils/_enums/typeography-variants.enum';
import {Button} from '../../button/button';
import {Typography} from '../../typography/typography';
import WalletConnectButton from '../../wallet-connect-button/wallet-connect-button';
import styles from './sales-box-connect-wallet.module.scss';

const SalesBoxConnectWallet = (): JSX.Element => {
    const data = useInstanceDetailPage();

    return (
        <div className={styles['connect-wallet-wrapper']}>
            <Typography variant={TypographyVariantsEnum.BODY_SMALL}>
                {data?.walletNotConnectedText?.content ?? ''}
            </Typography>
            <div className={styles['button-wrapper']}>
                <div>
                    <a href={data?.createWallet?.buttonUrl} target={'_blank'} rel={'noreferrer'}>
                        <Button variant={ButtonVariantsEnum.SECONDARY_OUTLINED}>
                            {data?.createWallet?.buttonText ?? ''}
                        </Button>
                    </a>
                </div>
                <div className={styles['wallet-connect-button']}>
                    <WalletConnectButton/>
                </div>
            </div>
        </div>
    )
}

export default SalesBoxConnectWallet;
